import { isConfigAs24 } from 'utils/url'

const USED_PAGES_FOR_LIST = ['base', 'contact']

export const shouldShowAs24OffersList = (page: string): boolean => {
  return isConfigAs24() && USED_PAGES_FOR_LIST.includes(page)
}
